<template>
  <div class="content-warp" v-if="org">
    <a-row class="brief-bar" type="flex" justify="space-between" align="middle">
      <a-row type="flex" justify="start" align="middle">
        <a-col class="brief-title">{{ org.on }}</a-col>
        <a-col class="brief-subtitle"></a-col>
        <a-col class="brief-subtitle"></a-col>
      </a-row>
      <a-col style="color: #999;"></a-col>
    </a-row>

    <a-form :form="form" @submit.prevent="handlePersonInfoSubmit">
      <a-row class="content-panle bg-white margin-0" :gutter="30">
        <a-col :span="24" class="padding-tb-md">
          <h3 class="panle-head">{{ $t('personalManaEdit.photosTitle') }}</h3>
          <a-form-item
            class="inline-form-item"
            :label="$t('personalManaEdit.photoTxt1')"
          >
            <a-card class="a-card-image">
              <img
                v-if="!currentImage"
                src="../../assets/empty_person.png"
                slot="cover"
              />
              <img v-else :src="currentImage" slot="cover" />

              <template class="ant-card-actions" slot="actions">
                <span
                  @click="
                    () => {
                      takePhotoModalVisible = true
                      takePhotoType = 1
                    }
                  "
                  style="color: rgba(0, 0, 0, 0.65);"
                >
                  <a-icon type="camera" />
                  {{ $t('personalManaEdit.takePhotoBtn') }}
                </span>

                <a-upload
                  accept="image/jpg,image/jpeg,image/png"
                  :showUploadList="false"
                  :beforeUpload="file => handleBeforeUploadPhoto(file, 1)"
                  v-decorator="[
                    'currentImage',
                    {
                      rules: [
                        {
                          required: false,
                          message: $t('personalManaEdit.photoTxt1Blank')
                        }
                      ]
                    }
                  ]"
                >
                  <a-icon :type="currentImgUploading ? 'loading' : 'upload'" />
                  {{ $t('personalManaEdit.uploadPhotoBtn') }}
                </a-upload>
              </template>
            </a-card>
          </a-form-item>
          <a-form-item
            class="inline-form-item"
            :label="$t('personalManaEdit.photoTxt2')"
          >
            <a-card class="a-card-image">
              <img
                v-if="!currentWithMaskImage"
                src="../../assets/empty_person.png"
                slot="cover"
              />
              <img v-else :src="currentWithMaskImage" slot="cover" />

              <template class="ant-card-actions" slot="actions">
                <span
                  @click="
                    () => {
                      takePhotoModalVisible = true
                      takePhotoType = 2
                    }
                  "
                  style="color: rgba(0, 0, 0, 0.65);"
                >
                  <a-icon type="camera" />
                  {{ $t('personalManaEdit.takePhotoBtn') }}
                </span>

                <a-upload
                  accept="image/jpg,image/jpeg,image/png"
                  :showUploadList="false"
                  :beforeUpload="file => handleBeforeUploadPhoto(file, 2)"
                  v-decorator="['currentWithMaskImage']"
                >
                  <a-icon
                    :type="currentWithMaskImgUploading ? 'loading' : 'upload'"
                  />
                  {{ $t('personalManaEdit.uploadPhotoBtn') }}
                </a-upload>
              </template>
            </a-card>
          </a-form-item>
          <a-form-item
            class="inline-form-item"
            :label="$t('personalManaEdit.IDCardPhotoTxt')"
          >
            <a-card class="a-card-image">
              <img
                v-if="!idCardImageUrl"
                src="../../assets/empty_person.png"
                slot="cover"
              />
              <img v-else :src="idCardImageUrl" slot="cover" />

              <template class="ant-card-actions" slot="actions">
                <WSReadCard :readMode="1" @readSuccess="handleReadIDCard">
                  <template v-slot:default="slotProps">
                    <span
                      @click="slotProps.readFunc"
                      :style="
                        slotProps.reading
                          ? 'cursor:not-allowed;color:#8C8C8C'
                          : 'color:#595959;'
                      "
                    >
                      <a-icon type="idcard" />
                      {{ $t('personalManaEdit.readIDCardBtn') }}
                    </span>
                  </template>
                </WSReadCard>
              </template>
            </a-card>
          </a-form-item>
          <a-form-item class="upload-image-tip">{{
            $t('personalManaEdit.uploadImageDesc')
          }}</a-form-item>
        </a-col>

        <a-col :span="24" class="padding-tb-md">
          <h3 class="panle-head">
            {{ $t('personalManaEdit.basicInfoTitle') }}
          </h3>
          <!-- 姓名 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.name')">
              <a-input
                :placeholder="$t('personalManaEdit.nameTxt')"
                v-decorator="[
                  'name',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('personalManaEdit.nameBlank')
                      },
                      { max: 20, message: $t('personalManaEdit.nameWarning') }
                    ],
                    validateTrigger: ['change', 'blur']
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 证件类型 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.IDType')">
              <a-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                :placeholder="$t('personalManaEdit.IDTypeTxt')"
                :options="idCardTypeOptions"
                @change="type => (idCardType = type)"
                v-decorator="[
                  'idCardType',
                  {
                    initialValue: 1,
                    rules: [
                      {
                        required: false,
                        message: $t('personalManaEdit.IDTypeBlank')
                      }
                    ],
                    validateTrigger: ['change', 'blur']
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 证件号 -->
          <a-col :span="8">
            <!-- 身份证 -->
            <a-form-item
              :label="$t('personalManaEdit.IDNumber')"
              v-if="idCardType === 1"
            >
              <a-input
                :placeholder="$t('personalManaEdit.IDNumberTxt')"
                v-decorator="[
                  'idNumber',
                  {
                    rules: [
                      {
                        required: false,
                        message: $t('personalManaEdit.IDNumberBlank')
                      },
                      { validator: checkIdNumber }
                    ],
                    validateTrigger: ['change', 'blur']
                  }
                ]"
              />
            </a-form-item>
            <!-- 护照 -->
            <a-form-item
              :label="$t('personalManaEdit.passportNumber')"
              v-if="idCardType === 2"
            >
              <a-input
                :placeholder="$t('personalManaEdit.passportNumberTxt')"
                v-decorator="[
                  'passportNumber',
                  {
                    rules: [
                      {
                        required: false,
                        message: $t('personalManaEdit.passportNumberBlank')
                      }
                    ],
                    validateTrigger: ['change', 'blur']
                  }
                ]"
              />
            </a-form-item>
            <!-- 港澳通行证 -->
            <a-form-item
              :label="$t('personalManaEdit.gatePassNumber')"
              v-if="idCardType === 3"
            >
              <a-input
                :placeholder="$t('personalManaEdit.gatePassNumberTxt')"
                v-decorator="[
                  'gatePassNumber',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('personalManaEdit.gatePassNumberBlank')
                      }
                    ],
                    validateTrigger: ['change', 'blur']
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 性别 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.sex')">
              <a-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                :placeholder="$t('personalManaEdit.sexTxt')"
                :options="enumsData.gender"
                v-decorator="['sex']"
              />
            </a-form-item>
          </a-col>
          <!-- 民族 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.nationality')">
              <a-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                :placeholder="$t('personalManaEdit.nationalityTxt')"
                :options="enumsData.ethnicity"
                v-decorator="['nation']"
              />
            </a-form-item>
          </a-col>
          <!-- 出生日期 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.birthday')">
              <a-date-picker
                dropdownClassName="form-date-picker"
                :getCalendarContainer="trigger => trigger.parentNode"
                style="width: 100%"
                :placeholder="$t('personalManaEdit.birthdayTxt')"
                v-decorator="['birthday']"
              />
            </a-form-item>
          </a-col>
          <!-- 手机号 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.phone')">
              <a-input
                :placeholder="$t('personalManaEdit.phoneTxt')"
                v-decorator="[
                  'phone',
                  {
                    rules: [
                       {
                        required: true,
                        message: $t('personalManaEdit.phoneBlank')
                      },
                      {
                        pattern: /^1[3456789]\d{9}$/,
                        message: $t('personalManaEdit.phoneWarning')
                      }
                    ],
                    validateTrigger: 'blur'
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 地址 -->
          <a-col :span="16">
            <a-form-item :label="$t('personalManaEdit.address')">
              <a-input
                :placeholder="$t('personalManaEdit.addressTxt')"
                v-decorator="[
                  'address',
                  {
                    rules: [
                      {
                        max: 100,
                        message: $t('personalManaEdit.addressWarning')
                      }
                    ],
                    validateTrigger: 'change'
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 备注 -->
          <a-col :span="24">
            <a-form-item :label="$t('personalManaEdit.remark')">
              <a-input
                :placeholder="$t('personalManaEdit.remarkTxt')"
                v-decorator="[
                  'remark',
                  {
                    rules: [
                      { max: 20, message: $t('personalManaEdit.remarkWarning') }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-col>
      </a-row>

      <a-row style="margin-top: 16px;">
        <a-col :span="24" :style="{ textAlign: 'right' }">
          <a-button type="primary" htmlType="submit" :loading="submitting">{{
            $t('personalManaEdit.submitBtn')
          }}</a-button>
          <a-button :style="{ marginLeft: '8px' }" @click="handleBackPage">{{
            $t('personalManaEdit.closeBtn')
          }}</a-button>
        </a-col>
      </a-row>
    </a-form>

    <!-- 拍照模态框  -->
    <Camera
      :show="takePhotoModalVisible"
      @hideModal="handleHideCameraModal"
      @afterUploadPhoto="handleAfterUploadPhoto"
    />

    <!-- 设置IC门禁卡模态框 -->
    <a-modal
      class="set-IC-card-modal"
      :title="$t('personalManaEdit.ICCardModal')"
      :cancelText="$t('personalManaEdit.closeBtn')"
      :okText="$t('personalManaEdit.submitBtn')"
      :visible="setICCardModalVisible"
      :confirmLoading="setICCardModalConfirmLoading"
      @ok="handleSubmitNewPerson"
      @cancel="
        () => {
          setICCardModalVisible = false
        }
      "
      :afterClose="handleSetICCardModalHide"
    >
      <div class="dup-person-info">
        <span v-if="reviewing"
          ><a-icon type="loading" />{{
            $t('personalManaEdit.rechecking')
          }}</span
        >
        <!-- <span v-if="!reviewing && !reviewTips && !dupPersonInfoArrs.length" style="color:#40a9ff">该人员未有重复信息！</span> -->
        <span v-if="!reviewing && reviewTips" style="color:#ff4d4f">{{
          reviewTips
        }}</span>
        <div
          v-if="!reviewing && dupPersonInfoArrs.length"
          style="color:#faad14"
        >
          <p v-for="(item, index) in dupPersonInfoArrs" :key="index">
            {{ item.name }}( {{ item.idNumber }} )
            {{ $t('personalManaEdit.recheckingTips') }} {{ item.org }}
          </p>
        </div>
      </div>

      <a-form-model
        ref="setICCardForm"
        :model="icCardForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-model-item
          :label="$t('personalManaEdit.ICCard')"
          prop="number"
          :placeholder="$t('personalManaEdit.ICCardTxt')"
        >
          <a-input v-model="icCardForm.number">
            <template slot="addonAfter">
              <WSReadCard :readMode="2" @readSuccess="handleReadICCard">
                <template v-slot:default="slotProps">
                  <a-button
                    type="primary"
                    :loading="slotProps.reading"
                    @click="slotProps.readFunc"
                    >{{ $t('personalManaEdit.readICCardBtn') }}</a-button
                  >
                </template>
              </WSReadCard>
            </template>
          </a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { checkIdNumberValid, compressImageFile } from '../../utils/utils'
import { mapState } from 'vuex'

import WSReadCard from '@/components/WSReadCard/WSReadCard'
import Camera from '@/components/Camera/Camera'

import { uploadBase64Img } from '@/api/fileUpload'
import { createPerson, checkRepeatedPerson } from '@/api/personalMana'

export default {
  name: 'personalManaNew',
  components: { WSReadCard, Camera },
  data() {
    return {
      org: null,
      // orgString: '',

      form: this.$form.createForm(this),
      idCardTypeOptions: [],
      idCardType: 1,
      submitting: false,

      // 人员基本信息集合
      personInfo: null,

      // 证件照
      idCardImageUrl: '',

      // 上传现场照片
      currentImgUploading: false,
      // 上传佩戴口罩的现场照片
      currentWithMaskImgUploading: false,

      // 现场照
      currentImage: null,
      // 佩戴口罩现场照
      currentWithMaskImage: null,
      // 要拍摄照片的类型
      takePhotoType: 1, // 1: 人员现场照；2：人员佩戴口罩的现场照
      // 拍摄照片模态框
      takePhotoModalVisible: false,

      // 设置门禁卡相关
      setICCardModalVisible: false,
      setICCardModalConfirmLoading: false,

      icCardForm: { number: '' },
      // icCardFormRules: {
      //   number: [
      //     { required: true, message: '请输入门禁卡编号', trigger: 'blur' }
      //   ]
      // },

      // 重复的人员信息
      reviewing: true,
      reviewTips: '',
      dupPersonInfoArrs: []
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData
    })
  },
  watch: {
    lang: function(lang) {
      this.$multiTab.rename(
        '/personal-mana/new',
        `${this.org.on} - ${this.$t('router.newPersonal')}`
      )
    }
  },
  beforeCreate() {
    // console.log('------personalManaNew beforeCreate-----', this.$route.query)
    if (!this.$route.query.oi) {
      this.$error({
        title: this.$t('personalManaEdit.pageErrTitle'),
        content: this.$t('personalManaEdit.pageErrContent'),
        okText: this.$t('personalManaEdit.backBtn'),
        onOk: () => {
          this.$multiTab.closeCurrentPage()
          this.$router.push({ name: 'personalManaIndex' })
        }
      })
    }
  },
  created() {
    this.idCardTypeOptions = this.enumsData.idType.map(item => {
      // 限制证件类型只能选择身份证
      if (item.value !== 1) item.disabled = true
      return item
    })
  },
  activated() {
    if (this.$route.query.oi) {
      this.$multiTab.close('/personal-mana/edit')
      this.org = this.$route.query
      this.$multiTab.rename(
        '/personal-mana/new',
        `${this.org.on} - ${this.$t('router.newPersonal')}`
      )
    }
  },

  methods: {
    moment,

    // 验证身份证号
    checkIdNumber(rule, value, callback) {
      if (value && !checkIdNumberValid(value)) {
        callback(this.$t('personalManaEdit.IDNumberWarning'))
        return
      }
      callback()
    },

    // 填写完基本信息后，点击提交，经验证后获取填写信息，构造vm.personInfo
    // 并打开门禁卡设置模态框，且同时进行身份信息查重
    handlePersonInfoSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.personInfo = values

          this.personInfo.birthday =
            this.personInfo.birthday &&
            this.personInfo.birthday.format('YYYY-MM-DD')
          this.personInfo.currentImage = this.currentImage
            ? this.currentImage
            : ''
          this.personInfo.currentWithMaskImage = this.currentWithMaskImage
            ? this.currentWithMaskImage
            : ''
          this.personInfo.idCardImageUrl = this.idCardImageUrl

          this.setICCardModalVisible = true
          this.reviewPersonInfo()
        }
      })
    },

    // 身份信息查重
    async reviewPersonInfo() {
      try {
        const res = await checkRepeatedPerson({
          idNumber: this.personInfo.idNumber,
          idType: this.personInfo.idCardType
        })

        this.dupPersonInfoArrs = res.data.collection.map(item => {
          return {
            name: item.name,
            idNumber: item.idNumber,
            org: item.deptFullName
          }
        })
        this.reviewing = false
      } catch (error) {
        this.reviewing = false
        this.reviewTips = this.$t('personalManaEdit.recheckingErr')
      }
    },

    // 设置好门禁卡后，点击提交，经验证后，提交新增人员信息到后台
    handleSubmitNewPerson() {
      this.$refs.setICCardForm.validate(async valid => {
        if (valid) {
          // console.log('-------this.personInfo------', this.personInfo)
          try {
            this.setICCardModalConfirmLoading = true
            this.personInfo.icCardNumber = this.icCardForm.number

            await createPerson({
              address: this.personInfo.address,
              birthDate: this.personInfo.birthday,
              cardSn: this.personInfo.icCardNumber,
              certificationTypeCode: Number(this.personInfo.idCardType),
              deptId: this.org.oi,
              ethnicityCode: Number(this.personInfo.nation),
              genderCode: Number(this.personInfo.sex),
              idNumber: this.personInfo.idNumber,
              idPhotoUrl: this.personInfo.idCardImageUrl,
              name: this.personInfo.name,
              phone: this.personInfo.phone,
              remark: this.personInfo.remark,
              scenePhoto2Url: this.personInfo.currentWithMaskImage,
              scenePhotoUrl: this.personInfo.currentImage
            })

            this.setICCardModalVisible = false
            this.setICCardModalConfirmLoading = false
            this.$notification.success({
              message: this.$t('personalManaEdit.addPersonalSuccess'),
              duration: 2
            })
            setTimeout(() => {
              this.handleBackPage()
            }, 2000)
          } catch (error) {
            this.setICCardModalConfirmLoading = false
          }
        }
      })
    },
    // 返回
    handleBackPage() {
      this.$multiTab.closeCurrentPage()
      this.$router.go(-1)
    },

    // 上传拍摄照片后
    handleAfterUploadPhoto(data) {
      if (this.takePhotoType === 1) {
        this.currentImage = data.data.collection[0]
        this.form.setFieldsValue({ currentImage: this.currentImage })
      }
      if (this.takePhotoType === 2) {
        this.currentWithMaskImage = data.data.collection[0]
        this.form.setFieldsValue({
          currentWithMaskImage: this.currentWithMaskImage
        })
      }
    },
    // 关闭拍照模态框
    handleHideCameraModal(data) {
      this.takePhotoModalVisible = data
    },

    // 上传照片前
    async handleBeforeUploadPhoto(file, type) {
      try {
        if (type === 1) this.currentImgUploading = true
        if (type === 2) this.currentWithMaskImgUploading = true

        compressImageFile(file, image => {
          this.handleUploadPhoto(image, type)
        })
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject()
      } catch (error) {
        this.currentImgUploading = this.currentWithMaskImgUploading = false
        this.$message.error(this.$t('personalManaEdit.uploadFail'))
        return Promise.reject(error)
      }
    },
    // 上传照片
    async handleUploadPhoto(image, type) {
      try {
        const base64Unhead = image.base64.replace(
          /^data:image\/\w+;base64,/,
          ''
        )
        const res = await uploadBase64Img({ data: base64Unhead, suffix: 'jpg' })

        if (type === 1) {
          this.currentImgUploading = false
          this.currentImage = res.data.collection[0]
          this.form.setFieldsValue({ currentImage: this.currentImage })
        }
        if (type === 2) {
          this.currentWithMaskImgUploading = false
          this.currentWithMaskImage = res.data.collection[0]
          this.form.setFieldsValue({
            currentWithMaskImage: this.currentWithMaskImage
          })
        }

        this.$message.success(
          `${image.name} ${this.$t('personalManaEdit.uploadSuccess')}`
        )
      } catch (error) {
        this.currentImgUploading = this.currentWithMaskImgUploading = false
        this.$message.error(
          `${image.name} ${this.$t('personalManaEdit.uploadFail')}`
        )
      }
    },

    // 设置门禁卡模态框关闭后
    handleSetICCardModalHide() {
      this.reviewing = true
      this.reviewTips = ''
      this.dupPersonInfoArrs = []

      this.icCardForm.number = ''
      this.personInfo = null

      this.$refs.setICCardForm.resetFields()
      this.setICCardModalConfirmLoading = false
    },

    // websocket方式读取身份证信息
    async handleReadIDCard(data) {
      try {
        this.form.setFieldsValue({
          name: data.name,
          idNumber: data.idNumber,
          idCardType: 1, // 身份证
          sex: data.sex,
          nation: data.nation,
          birthday: this.moment(data.birthday),
          address: data.address
        })
        this.idCardImageUrl = 'data:image/png;base64,' + data.image

        const res = await uploadBase64Img({ data: data.image, suffix: 'png' })
        this.idCardImageUrl = res.data.collection[0]
      } catch (error) {}
    },

    // websocket方式读取IC信息
    handleReadICCard(data) {
      this.icCardForm.number = data.number
    }
  }
}
</script>

<style>
.inline-form-item {
  display: inline-block;
  margin: 0 15px;
}
.a-card-image > .ant-card-cover {
  width: 220px;
  height: 293px;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.a-card-image > .ant-card-cover > img {
  max-height: 100%;
  max-width: 100%;
}
.set-IC-card-modal .ant-input-group-addon {
  border: none;
}
</style>
<style scoped>
.brief-bar {
  background-color: #fff;
  margin: 5px 0;
  padding: 10px 16px;
  border-radius: 5px;
}
.brief-bar .brief-title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin-right: 10px;
}
.brief-bar .brief-subtitle {
  margin-right: 10px;
  color: #999;
}

.set-IC-card-modal .dup-person-info {
  padding: 0 34px 10px;
}

.submit-btn-area {
  padding: 10px 20px;
  background: #fff;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #e8e8e8;
}

.upload-image-tip {
  font-size: 12px;
  line-height: 20px;
  margin: 5px 15px 0 15px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
